<template>
  <div>
    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fas fa-cogs"></i><b>New Registration:</b>
      </template>
    </Subtitle>

    <div id="EDSRegistration">
      <form class="card p-0 mb-1" id="SearchForm">
        <!-- <div class="card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
        <h5><small class="text-muted"><b><i class="fas fa-search-plus"></i>Search: HSN Required)</b></small></h5>
  </div> -->
        <div class="form-row p-1">
          <div class="form-group col-sm-3">
            <label for="NewHSN" class="label-small">HSN</label>
            <input
              id="NewHSN"
              ref="NewHSN"
              v-model="HSN"
              placeholder="HSN"
              maxlength="9"
              class="form-control form-control-xs"
            />

            <div class="row" v-show="$v.HSN.$error">
              <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.HSN.required"
                  >HSN is required.</small
                >
              </div>
            </div>
            <div class="row" v-show="$v.HSN.$error">
              <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.HSN.minLength"
                  >minimum 9 digits required.</small
                >
              </div>
            </div>
            <div class="row" v-show="$v.HSN.$error">
              <div class="col-sm-12">
                <small class="sml-red" v-if="!$v.HSN.numeric"
                  >HSN must be a number.</small
                >
              </div>
            </div>
          </div>

          <div class="form-group col-sm-1">
            <label for="inputPassword4" class="label-small"> </label>
            <div class=" ">
              <button
                v-on:click="GetHsnInfo"
                type="button"
                class="btn btn-primary btn-sml mt-1"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="row no-gutters mt-2">
        <div class="col-4 pr-1" v-if="Showinfo">
          <div
            class="card"
            style="padding-bottom: 0px"
            v-if="Patient != null && (HSN != '' || HSN != null)"
          >
            <div
              class="card-header d-flex align-items-center pl-1"
              style="height: 2rem; text-align: left"
            >
              <h5>
                <small class="text-muted"
                  ><b
                    ><i class="fas fa-user-injured"></i>Patient:
                    {{ Patient.firstName }}  {{ Patient.lastName }}
                  </b></small
                >
              </h5>
            </div>
            <div class="card-body p-2 mb-3">
              <div class="row">
                <span for="cname" class="col-sm-4"><b>HSN:</b></span>
                <span class="col-sm-8" type="text">{{ HSN }}</span>
              </div>
              <div class="row">
                <span for="cname" class="col-sm-4"><b>Address:</b></span>
                <span class="col-sm-8" type="text"
                  >{{ Patient.address1 }} {{ Patient.address2 }}</span
                >
              </div>
              <div class="row pb-1">
                <span for="cname" class="col-sm-4"><b>DOB:</b></span>
                <span class="col-sm-8" type="text"
                  >{{ Patient.birthDay | moment }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-8 pr-1" v-if="Showinfo">
          <div
            class="card"
            v-if="Patient != null && (HSN != '' || HSN != null)"
          >
            <div
              class="card-header d-flex align-items-center pl-1"
              style="height: 2rem; text-align: left"
            >
              <h5>
                <small class="text-muted"
                  ><b
                    ><i class="fas fa-user-injured"></i>Enter Registration Info:
                  </b></small
                >
              </h5>
            </div>
            <div class="card-body p-2">
              <div class="row">
                <span for="cname" class="col-sm-3"><b>Effective Date:</b></span>
                <span class="col-sm-4" type="text">
                  <datepicker
                    :open-date="new Date()"
                    :disabledDates="{ from: new Date(Date.now() + 1) }"
                    v-model="effectiveDate"
                    :format="dateFormat"
                    id="effDate"
                    :bootstrap-styling="true"
                    :input-class="datapickClass"
                    name="expirydatepicker"
                  ></datepicker>
                  <!-- <input id="NewHSN" ref="NewHSN" v-model="effectiveDate" placeholder="Effective Date" maxlength="9" class="form-control form-control-xs"> -->
                </span>
                <!-- <span   class="col-sm-4" type="text" v-if="$v.effectiveDate.$error"> 
                            <small class="sml-red col-sm-8" v-if="(!$v.effectiveDate.val)">Effective date is required.</small>
                        </span>  -->
              </div>
              <div class="row">
                <span for="cname" class="col-sm-3"><b></b></span>
                <span
                  class="col-sm-9"
                  type="text"
                  v-if="$v.effectiveDate.$error"
                >
                  <small class="sml-red" v-if="!$v.effectiveDate.val"
                    >Effective date is required.</small
                  >
                </span>
                <span
                  class="col-sm-8"
                  type="text"
                  v-if="!$v.effectiveDate.$error"
                >
                  <small class="sml-red"></small>
                </span>
              </div>
              <div class="card-body p-0">
                <div class="row">
                  <span for="cname" class="col-sm-3"
                    ><b>Select a Risk Factor:</b></span
                  >
                  <span class="col-sm-9" type="text">
                    <select
                      id="Status"
                      v-model="Risks"
                      class="form-control form-control-sm select-css"
                    >
                      <!-- v-on:change="RiskFactorChange($event)" -->
                      <option
                        v-for="option in RisFactors"
                        v-bind:value="{ id: option.id, text: option.text }"
                        :key="option.id"
                      >
                        <strong>{{ option.text }}</strong>
                      </option>
                    </select>
                  </span>
                </div>
                <div class="row">
                  <span for="cname" class="col-sm-3"><b></b></span>
                  <span class="col-sm-9" type="text" v-if="$v.Risks.$error">
                    <small class="sml-red" v-if="!$v.Risks.val"
                      >Risk Factor is required.</small
                    >
                  </span>
                  <span class="col-sm-8" type="text">
                    <small class="sml-red"></small>
                  </span>
                </div>
              </div>

              <div class="card-body p-0" v-if="ShowFacilities">
                <div class="row">
                  <span for="cname" class="col-sm-3"
                    ><b>Select Facility:</b></span
                  >
                   <span class="col-sm-9" type="text">
                    <vue-bootstrap-typeahead
                      ref="searchbox"
                      :inputClass="TypeHeadinptClass" 
                      @input="FacilityChange"
                      v-model="SelectedFacility"
                      :data="Facilities"
                      @hit="SelectFacId = $event"
                      :serializer="(item) =>item.facno +'-'+item.facname + '@'+item.site"
                      textVariant=".text-info"
                      placeholder="Search Facility Name"
                      size="sm"
                      backgroundVariant="bg-light"
                      :maxMatches="30"
                    >
                      <template slot="prepend">
                        <span class="input-group-text" style="font-size: 0.7rem"
                          ><i class="fas fa-search fa-sm"></i
                        ></span>
                      </template>
                    </vue-bootstrap-typeahead>
                    <span
                      class="col-sm-3"
                      type="text"
                      v-if="$v.SelectFacId.$error"
                    >
                      <small class="sml-red col-sm-9" v-if="!$v.SelectFacId.val"
                        >Facility is required.</small
                      >
                    </span>
                  </span>
                </div>
              </div>
              <div
                class="row no-gutters p-0"
                v-if="SelectFacId != '' && SelectFacId != null"
              >
                <span for="cname" class="col-sm-3"
                  ><b>Facility Information:</b></span
                >
                <!-- <span class="col-sm-8" > -->

                <ul class="col-sm-9 p-0 list-group list-group-flush">
                  <li class="list-group-item">
                    <b>Facility Number:</b> {{ SelectFacId.facno }}
                  </li>
                  <li class="list-group-item">
                    <b>Facility Name:</b> {{ SelectFacId.facname }}
                  </li>
                  <li class="list-group-item">
                    <b>Facility Address:</b> {{ SelectFacId.site }}
                  </li>
                </ul>
              </div>

              <div class="row">
                <span for="cname" class="col-sm-3"><b></b></span>
                <span class="col-sm-9" type="text">
                  <button
                    v-on:click="RegisterEDS"
                    type="button"
                    class="btn btn-primary btn-sml mt-2"
                  >
                    Register 
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import LayoutDefault from "@/Common/Default/DefaultLayout.vue";
import Subtitle from "@/Common/Default/SubTitle.vue";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import { isNullOrUndefined } from "util";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import {
  required,
  minLength,
  maxLength,
  between,
  withParams,
  numeric,
} from "vuelidate/lib/validators";
const alphaNum = helpers.regex("alphaNum", /^\d{1,5}\s\w*/);
Vue.use(Vuelidate);
export default {
  name: "DentalHome",
  props: { LeadAssessor: false, ServiceID: "" },
  data: function () {
    return {
      TypeHeadinptClass:'form-control',
      ShowFacilities: false,
      Facilities: "",
      SelectedFacility: "",
      SelectFacId: "",
      Patient: "",
      Risks: "",
      RisFactors: "",
      datapickClass: "form-control form-control-xs my-0",
      PopUpVar: PopUpVariant,
      effectiveDate: "",
      HSN: "",
      ProviderNo: "",
      Showinfo: false,
      showError: false,
      MsgPopup: false,
      showModal: false,
    };
  },
  watch: {
    Risks: function (currentValue) {
      if (this.Risks.id == 10 || this.Risks.id == 11 || this.Risks.id == 16) {
        this.ShowFacilities = true;
      } else {
        this.ShowFacilities = false;
        this.SelectFacId = "";
      }
    },
    $route(to, from) {},
    HSN: function () {
      //this.Showinfo = false;
     // //console.log('HSN:'+ this.HSN)
      if (this.HSN == null || this.HSN.length < 9) {
        this.$refs.NewHSN.focus();
        this.Showinfo = false;
        this.ShowFacilities = false;
        this.SelectFacId = "";
        this.Risks="";
        this.effectiveDate="";
      }
    },
  },
  components: {
    Card,
    CardBody,
    TileNote,
    Datepicker,
    Subtitle,
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  methods: {
    FacilityChange() {
      if (this.SelectedFacility == "" || this.SelectedFacility == null) {
        this.SelectFacId = null;
      }
    },
    Show() {
      this.Showinfo = true;
    },
    ClosePopup() {
      this.showError = false;
    }, //FHRegisterEDS
    RegisterEDS() {
      var vm = this;
      //////console.log(vm.effectiveDate)
     ////console.log(vm.$v);
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        var vm = this;
        var url = "/SaskHealthApi/Host/RegisterCovid";
        var effectdate = moment(vm.effectiveDate, "YYYY-MM-DD").format(
          "YYYYMMDD"
        );
        var EffecValDate = moment(vm.effectiveDate, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        );
        var params = new URLSearchParams();
        params.append("HSN", this.HSN);
        params.append("effectivedate", effectdate);
        params.append("RiskFactor", vm.Risks.id);
        if (
          vm.SelectFacId == "" ||
          vm.SelectFacId == null ||
          vm.SelectFacId == undefined
        ) {
          params.append("FacilityNo", "0000");
          params.append("FacilityName", "  ");
        } else {
          params.append("FacilityNo", vm.SelectFacId.facno);
          params.append("FacilityName", vm.SelectFacId.facname);
        }
         params.append("EffectDateVal", EffecValDate);
        // alert(EffecValDate)
        axios({
          method: "post",
          url: url,
          headers: {
            Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
          },
          data: params,
        })
          .then(function (response) {
            //////console.log(response.data);
            vm.showMsg(response.data, "", "Patient Registration");
          })
          .catch(function (er) {
            //////console.log(er);
            if (er.status == 400) {
              vm.showMsg(er.data.message, "", "Patient Registration");
              ////console.log(er);
              ////console.log(er.data.messag);
            } else if (er.status == 500) {
              vm.showError = true;
              if (er.data.message != null)
                vm.showMsg(er.data.message, "", "Patient Registration");
           
              else
                vm.showMsg(
                  "Network Related Error ! Please contact system administrator",
                  "",
                  "Patient Registration"
                );
              
            }
          });
      }
    },
    GetFacilities() {
      var vm = this;
      axios
        .get("SaskHealthApi/Codes/GetFacilities", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
        })
        .then(function (response) {
          vm.Facilities = response.data;
          //////console.log('at fac');
          //////console.log(response.data);
        })
        .catch(function (er) {
          ////console.log(er);
          if (er.status == 400) {
            //vm.showMsg(er.data.message, "", "Patient Registration");
          } else if (er.status == 500) {
          }
        });
    },
    GetRiskFactors() {
      var vm = this;
      axios
        .get("SaskHealthApi/Codes/GetRiskFactors", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
        })
        .then(function (response) {
          vm.RisFactors = response.data;
        })
        .catch(function (er) {
          ////console.log(er);
          if (er.status == 400) {
            //vm.showMsg(er.data.message, "", "Patient Registration");
          } else if (er.status == 500) {
          }
        });
    },
    GetHsnInfo() {
      var vm = this;
      ////console.log(vm.$v);
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        var params = new URLSearchParams();
        params.append("HSN", this.HSN);
        axios
          .get("SaskHealthApi/Host/GetHsnInq", {
            headers: { Authorization: "Bearer " + localStorage.access_token },
            params,
          })
          .then(function (response) {
            vm.Patient = response.data;
            vm.Showinfo = true;
          })
          .catch(function (er) {
            ////console.log(er);
            if (er.status == 400) {
              vm.showMsg(er.data.message, "", "Patient Registration");
            } else if (er.status == 500) {
              if (er.data.message != null)
                vm.showMsg(er.data.message, "", "Patient Registration");
              else
                vm.showMsg(
                  "Network Related Error ! Please contact system administrator",
                  "",
                  "Patient Registration"
                );
            }
          });
      }
    },

    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    ValidateFacility() {
        if (this.Showinfo) {
      if (this.Risks.id == 10 || this.Risks.id == 11 || this.Risks.id == 16) {
        if (
          this.SelectFacId == "" ||
          this.SelectFacId == null ||
          this.SelectFacId == undefined
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
        } else {
        return true;
      }
    },
    ValidateRisk() {
      if (this.Showinfo) {
        // alert('her')
        if (this.HSN != "" || this.HSN != null) {
          if (
            this.Risks === null ||
            this.Risks === "" ||
            this.Risks === "undefined"
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    ValidateEffectDate() {
      if (this.Showinfo) {
        // alert('her')
        if (this.HSN != "" || this.HSN != null) {
          if (
            this.effectiveDate === null ||
            this.effectiveDate === "" ||
            this.effectiveDate === "undefined"
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
  },
  computed: {},
  created: function () {
    this.$emit("update:layout", LayoutDefault);
    this.AppServiceID = this.$store.getters.GetFHServiceID;
    this.dateFormat = this.$store.getters.GetDateFormat;
    this.ServiceDate = moment(new Date()).format("YYYY/MM/DD");
    this.GetRiskFactors();
    this.GetFacilities();
  },
  beforeCreate: function () {
    this.$store.dispatch("AddServiceID", this.$store.getters.GetFHServiceID);
    this.$store.dispatch("GetMenuItems", this.$store.getters.GetFHServiceID);
  },
  mounted: function () {
    //this.$refs.SearchClinic.inputValue = 'Some value'
    this.$nextTick(function () {});
  },

  validations() {
    return {
      // SelectedClinic : {
      //   required,
      // },
      // selectedProvider : {
      //   required,
      // },
      HSN: {
        required,
        numeric,
        minLength: minLength(9),
      },
      effectiveDate: {
        val: (value) => this.ValidateEffectDate(),
      },
      Risks: {
        val: (value) => this.ValidateRisk(),
      },
      SelectFacId: {
        val: (value) => this.ValidateFacility(),
      },
    };
  },
};
</script>
<style scopped>
.ulClass {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px !important;
}
.liClass {
  border: 1px solid;
  margin-bottom: 5px;
  border-radius: 5px;
  margin-right: 5px;
  padding: 0 5px;
}
.file-name {
  min-width: 150px;
  font-size: 13px;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px !important;
}
.file-details {
  margin-bottom: 0px !important;
}

.row.no-gutter [class*="col-"] {
  padding-right: 1px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0px 15px;
  margin-bottom: -1px;
  border: 1px solid #ddd;
  background-color: blue;
  line-height: 1em;
}
/* remove right padding from first column */
/* .row.no-gutter [class*='col-']:first-child {
  padding-right:5px;
} */
/* remove left padding from first column */
/* .row.no-gutter [class*='col-']:last-child {
  padding-left:5px;
} */

/* only for column content visible */
.col-lg-1 > div {
  background-color: #ddd;
}

#docimg {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 10px; */
}
#line {
  border-top: 1px solid rgba(7, 14, 109, 0.25);
  /* border-bottom:1px solid #c00;
  border-bottom: 1px solid rgba(255,255,255,.25); */
}
.select-css {
  display: block;
  font-size: 14px;
  /* font-family: sans-serif; */
  font-weight: 600;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #aaa;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  /* appearance: none; */
  background-color: #fff;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
    linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}
#ServiceCodeGrid .VuePagination__count {
  visibility: hidden;
  height: 0px;
}
#ServiceCodeGrid .pagination {
  height: 0px;
}
/* #ServiceCodeGrid tr td:nth-child(2) {
    width: 9.5rem !important;
    padding:3px !important;
    /* margin:0rem !important;
}  */

.highlight {
  background-color: #fff2ac;
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
}
.bd-highlight {
  /* background-color: rgba(86,61,124,0.15); */
  /* border: 1px solid rgba(86,61,124,0.15); */
  background-image: linear-gradient(to right, #ffe359 0%, #fff2ac 100%);
  /* background-image: linear-gradient(to right, #ac9732ad 0%, #cebc5985 100%); */
  /* text-decoration-line: underline; */
  font-weight: bold;
  padding: 0.4rem;
  margin: 0rem !important;
}

.cov {
  font-size: 1.3rem;
  font-weight: bolder;
  /* padding: .2rem; */
  margin: 0rem !important;
}
</style>